<template>
    <div class="menu-container column">
        <div class="menu-button "
         :class="language==='en'?'adver-en':'adver-zh'"
         @click="handdleClick(menuListParse.advertiser.advertiserPage)"
         v-if="menuListParse.advertiser">
        </div>
        <div class="menu-button "
         :class="language==='en'?'print-en':'print-zh'"
         @click="showModule('print')"
         v-if="menuListParse.print">
    </div>
    <div class="menu-button "
         :class="language==='en'?'help-en':'help-zh'"
         v-if="menuListParse.help"
         @click="showModule('help')">
    </div>
    </div>
</template>
<script>
import { isNumber, validURL } from '@/utils';
import { mapState } from 'vuex';

export default {
  name: 'leftmenu',
  props: {
    menuData: Array,
  },
  methods: {
    handdleClick(s) {
      if (validURL(s)) {
        window.open(s, 'top');
      } else if (isNumber(s)) {
        this.gotoPage(s);
      } else {
        // return false;
      }
    },
    gotoPage(n) {
      // 跳转到指定页
      this.$store.commit('updateCurrentPage', {
        currentPage: parseInt(n / 2, 0),
      });
    },
    showModule(name) {
      this.$store.commit('updateView', {
        view: name,
      });
    },
  },
  computed: {
    ...mapState({
      language: (state) => state.language,
    }),
    menuListParse() {
      const arr = {};
      this.menuData.forEach((element) => {
        arr[element.name] = element;
      });
      return arr;
    },
  },
};
</script>
<style lang="less" scoped>
.menu-container {
  //width: 350px;
  //height: 30px;
  //background: #090e18;
  display: flex;
  .menu-button {
    width: 80px;
    height: 30px;
    line-height: 30px;
    background-color: #0000008c;
    background-repeat: no-repeat;
    margin-top: 1px;
    font-size: 10px;
    cursor: pointer;
    color: white;
    .box {
      width: 84px;
      bottom: 66px;
      overflow: hidden;
      position: relative;
      pointer-events: none;
      .show {
        opacity: 1;
        transform: translateY(0%);
      }
    }
    .act {
      pointer-events: visible;
    }
    &-list {
      transition: all 0.5s;
      transform: translateY(100%);
      position: relative;
      bottom: 0px;
      left: 0;
      // width: 84px;
      margin: 0;
      padding: 0;
      opacity: 0;
      overflow: hidden;
      li:hover {
        background-color: transparent;
        opacity: 0.8;
      }
    }
    .supplier {
      width: 145px;
      bottom: 99px;
    }
    .magzine {
      width: 85px;
      bottom: 99px;
    }
  }
  .menu-button:hover {
    background-color: grey;
  }
  .menu-button.adver-zh {
    background-image: url("~@/assets/icon/icon_advertiser.png");
    background-position: center;
    width: 80px;
  }
  .menu-button.adver-en {
    background-image: url("~@/assets/icon/icon_advertiser_eng.png");
    width: 80px;
  }
  .menu-button.print-zh {
    background-image: url("~@/assets/icon/icon_print.png");
    width: 80px;
  }
  .menu-button.print-en {
    background-image: url("~@/assets/icon/icon_print_eng.png");
    width: 80px;
  }
  .menu-button.help-zh {
    background-image: url("~@/assets/icon/icon_help.png");
    width: 80px;
  }
  .menu-button.help-en {
    background-image: url("~@/assets/icon/icon_help_eng.png");
    width: 80px;
  }
}
</style>
